import { CategoryInterface, SubcategoryInterface } from "../type";
import { ServiceCategoryNewProxy } from "@me-team/host/main/graphql/types";

class CategoryService {
    public static categoryModuleCreator = (
        serviceCategories: ServiceCategoryNewProxy[],
        categoryId: number | null,
        subcategoryId: number | null
    ): CategoryInterface[] => {
        const isActiveCategories = serviceCategories.filter((category) => !category.deleted);
        return isActiveCategories.map((serviceCategory) => {
            return {
                id: serviceCategory.id,
                name: serviceCategory.name,
                isOpen: !!(serviceCategory.id === categoryId && subcategoryId),
                isPicked: !!(serviceCategory.id === categoryId && !subcategoryId),
                isSubcategoryPiked: !!(serviceCategory.id === categoryId && subcategoryId),
                subcategoryList: this.subcategoryModuleCreator(serviceCategory.childCategories, subcategoryId),
            };
        });
    };

    public static subcategoryModuleCreator = (
        subcategories: ServiceCategoryNewProxy[],
        currentSubcategoryId: number
    ): SubcategoryInterface[] => {
        const isActiveSubcategories = subcategories.filter((subcategory) => !subcategory.deleted);
        return isActiveSubcategories.map((subcategory) => {
            return {
                id: subcategory.id,
                name: subcategory.name,
                isPicked: subcategory.id === currentSubcategoryId,
            };
        });
    };
}

export default CategoryService;
